// extracted by mini-css-extract-plugin
module.exports = {"table":"instructions-table_table__vKgIy","small":"instructions-table_small__4rsbf"};